import { useFormContext } from "react-hook-form";
import { GlobalAttributeFields } from "../forms/schema";
import {
	FixCatalogGlobalAttributesAccentApplicationText,
	FixCatalogGlobalAttributesAccentColorText,
	FixCatalogGlobalAttributesCaseColorText,
	FixCatalogGlobalAttributesDistressingText,
	FixCatalogGlobalAttributesHingeText,
	FixCatalogGlobalAttributesPackagingText,
	FixCatalogGlobalAttributesProfileText,
	FixCatalogGlobalAttributesShapeText,
	FixCatalogGlobalAttributesSpeciesText,
	NewOrderBuildGridFinishColumnHeader,
	SaveDraftTHeadProductLine
} from "../../constants";
import {
	GlobalsSummaryContainer,
	GlobalsSummaryField,
	GlobalsSummaryFieldLabel,
	GlobalsSummaryFieldValue
} from "../addGlobalAttributes.styles.ts";
import { DoorStyleText, FlyoutConstructionLabel } from "constants/text";
import { formatFinishDescription } from "../../utils/NewOrderUtils.tsx";

const StepFive = () => {
	const { getValues } = useFormContext<GlobalAttributeFields>();
	const {
		productLine: selectedProductLine,
		doorStyle: selectedDoorStyle,
		shape: selectedShape,
		profile: selectedProfile,
		hinge: selectedHinge,
		caseColor: selectedCaseColor,
		species: selectedSpecies,
		finish: selectedFinish,
		distressing: selectedDistressing,
		accentColor: selectedAccentColor,
		accentApplication: selectedAccentApplication,
		construction: selectedConstruction,
		packaging: selectedPackaging
	} = getValues();

	return (
		<GlobalsSummaryContainer data-testid="global-attribute-modal-selection">
			{selectedProductLine?.description && (
				<GlobalsSummaryField>
					<GlobalsSummaryFieldLabel>{SaveDraftTHeadProductLine}</GlobalsSummaryFieldLabel>
					<GlobalsSummaryFieldValue>{selectedProductLine.description}</GlobalsSummaryFieldValue>
				</GlobalsSummaryField>
			)}
			{selectedDoorStyle?.description && (
				<GlobalsSummaryField>
					<GlobalsSummaryFieldLabel>{DoorStyleText}</GlobalsSummaryFieldLabel>
					<GlobalsSummaryFieldValue>{selectedDoorStyle.description}</GlobalsSummaryFieldValue>
				</GlobalsSummaryField>
			)}
			{selectedShape?.description && (
				<GlobalsSummaryField>
					<GlobalsSummaryFieldLabel>{FixCatalogGlobalAttributesShapeText}</GlobalsSummaryFieldLabel>
					<GlobalsSummaryFieldValue>{selectedShape.description}</GlobalsSummaryFieldValue>
				</GlobalsSummaryField>
			)}
			{selectedProfile?.description && (
				<GlobalsSummaryField>
					<GlobalsSummaryFieldLabel>{FixCatalogGlobalAttributesProfileText}</GlobalsSummaryFieldLabel>
					<GlobalsSummaryFieldValue>{selectedProfile.description}</GlobalsSummaryFieldValue>
				</GlobalsSummaryField>
			)}
			{selectedHinge?.description && (
				<GlobalsSummaryField>
					<GlobalsSummaryFieldLabel>{FixCatalogGlobalAttributesHingeText}</GlobalsSummaryFieldLabel>
					<GlobalsSummaryFieldValue>{selectedHinge.description}</GlobalsSummaryFieldValue>
				</GlobalsSummaryField>
			)}
			{selectedCaseColor?.description && (
				<GlobalsSummaryField>
					<GlobalsSummaryFieldLabel>{FixCatalogGlobalAttributesCaseColorText}</GlobalsSummaryFieldLabel>
					<GlobalsSummaryFieldValue>{selectedCaseColor.description}</GlobalsSummaryFieldValue>
				</GlobalsSummaryField>
			)}
			{selectedSpecies?.description && (
				<GlobalsSummaryField>
					<GlobalsSummaryFieldLabel>{FixCatalogGlobalAttributesSpeciesText}</GlobalsSummaryFieldLabel>
					<GlobalsSummaryFieldValue>{selectedSpecies.description}</GlobalsSummaryFieldValue>
				</GlobalsSummaryField>
			)}
			{selectedFinish?.description && (
				<GlobalsSummaryField>
					<GlobalsSummaryFieldLabel>{NewOrderBuildGridFinishColumnHeader}</GlobalsSummaryFieldLabel>
					<GlobalsSummaryFieldValue>{formatFinishDescription(selectedFinish)}</GlobalsSummaryFieldValue>
				</GlobalsSummaryField>
			)}
			{selectedDistressing?.description && (
				<GlobalsSummaryField>
					<GlobalsSummaryFieldLabel>{FixCatalogGlobalAttributesDistressingText}</GlobalsSummaryFieldLabel>
					<GlobalsSummaryFieldValue>{selectedDistressing.description}</GlobalsSummaryFieldValue>
				</GlobalsSummaryField>
			)}
			{selectedAccentColor?.description && (
				<GlobalsSummaryField>
					<GlobalsSummaryFieldLabel>{FixCatalogGlobalAttributesAccentColorText}</GlobalsSummaryFieldLabel>
					<GlobalsSummaryFieldValue>{selectedAccentColor.description}</GlobalsSummaryFieldValue>
				</GlobalsSummaryField>
			)}
			{selectedAccentApplication?.description && (
				<GlobalsSummaryField>
					<GlobalsSummaryFieldLabel>
						{FixCatalogGlobalAttributesAccentApplicationText}
					</GlobalsSummaryFieldLabel>
					<GlobalsSummaryFieldValue>{selectedAccentApplication.description}</GlobalsSummaryFieldValue>
				</GlobalsSummaryField>
			)}
			{selectedConstruction?.description && (
				<GlobalsSummaryField>
					<GlobalsSummaryFieldLabel>{FlyoutConstructionLabel}</GlobalsSummaryFieldLabel>
					<GlobalsSummaryFieldValue>{selectedConstruction.description}</GlobalsSummaryFieldValue>
				</GlobalsSummaryField>
			)}
			{selectedPackaging?.description && (
				<GlobalsSummaryField>
					<GlobalsSummaryFieldLabel>{FixCatalogGlobalAttributesPackagingText}</GlobalsSummaryFieldLabel>
					<GlobalsSummaryFieldValue>{selectedPackaging.description}</GlobalsSummaryFieldValue>
				</GlobalsSummaryField>
			)}
		</GlobalsSummaryContainer>
	);
};

export default StepFive;
